<template>
  <div class="solicitarSenha">
    <div class="container">
      <v-snackbar
        v-model="loginSuccess"
        color="success"
        top
        :timeout="8000"
        multi-line
      >
        <p>
          Alteração efetuada com sucesso! Instrução foram enviadas com sucesso
          para {{ emailCadastrado }}.
        </p>
        <v-btn color="info" @click="loginSuccess = false">Ok</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top :timeout="8000">
        <span
          >Nenhum cadastro encontrado para este CPF/CNPJ! Verifique os campos
          informados e tente novamente.</span
        >
        <v-btn color="info" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Recuperar Senha</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 lg4>
          <v-card hover class="ma-4">
            <v-card-title>Redefinir senha</v-card-title>
            <v-card-text>
              <span class="body-2"
                >Informe seu CPF/CNPJ abaixo e enviaremos um e-mail contendo um
                link para definir uma nova senha.</span
              >

              <v-form ref="form" class="my-3">
                <v-text-field
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  v-model="cpfCnpj"
                  :rules="regrasObrigacao"
                  label="CPF/CNPJ"
                  required
                  clearable
                  prepend-icon="account_circle"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <!-- <v-btn
                color="#006eb8"
                dark
                outlined
                small
                type="submit"
                router
                to="RecuperarEmail"
              >
                <v-icon small left>history</v-icon>
                <span>Recuperar e-mail</span>
              </v-btn> -->
              <v-spacer></v-spacer>
              <v-btn
                small
                color="#006eb8"
                dark
                type="submit"
                @click="recuperarSenha"
              >
                <v-icon left>send</v-icon>
                <span>Enviar senha</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  data() {
    return {
      cpfCnpj: null,
      loginSuccess: false,
      loginFail: false,
      emailCadastrado: "",
      regrasObrigacao: [(v) => !!v || "Campo obrigatório!"],
    };
  },
  methods: {
    recuperarSenha() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port == "8081" ? "8080" : window.location.port;
      axios.defaults.baseURL = `${protocol}//${hostname}:${port}/controleacesso/servico/api/esqueceusenha/sistema/DESIF_EXTERNO`;

      console.log(axios.defaults.baseURL);

      if (!this.$refs.form.validate()) {
        // console.log("Erro!");
      } else {
        this.cpfCnpj = this.removeMask();
        axios
          .put(`/login/${this.cpfCnpj}`)
          .then((res) => {
            this.emailCadastrado = res.data;
            console.log(this.emailCadastrado);
            this.loginSuccess = true;
          })
          .catch((error) => {
            console.log(error);
            this.loginFail = true;
          });
      }
    },
    removeMask() {
      return this.cpfCnpj.replace(/\D/g, "");
    },
  },
};
</script>

<style scoped>
</style>
